import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

interface Payload {
  place: uui.domain.client.gps.GeocodedPlace
  snapToRoad?: boolean
}

/**
 * Search places on the map
 *
 * @private
 */
export const getPlace = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.client.Location,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('ui/getPlace', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/ui/getPlace', {
      category: 'rpc',
      type: 'rpc/ui/getPlace',
      params: payload,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }

    return result.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {getPlace}`,
      { tags: ['rpc', 'ui', 'getPlace'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Get place failed`,
      error,
    })
  }
})
